<template>
    <div class="category-filter"> 
        <categories-list :categories="unselectedCategories" :label="label" 
            @newCategoryAdded="handleNewCategory"
            @selectedCategory="selectNewCategory">
        </categories-list>
        <div class="selected-categories">
            <category 
                v-for="(category, index) in selectedCategories" 
                :key="index" 
                :label="category.label"
                :selected="true"
                :disabled="false"
                @click="unselectCategory(category)">
            </category>
        </div>
    </div>
</template>

<script>
import CategoriesList from './CategoriesList.vue'
import Category from './Category'

import getAllCategories from '@/gql/categories/getAllCategories.gql'

export default {
    components: {
        Category,
        CategoriesList
    },
    props: {
        label: {
            type: String
        }, 
        initialCategories: {
            type: Array,
            default: () => {return []}
        }
    },
    computed: {
        userId() {
            return this.$store.state.user.id;
        },
    },
    apollo: {
        categories: {
            query: getAllCategories,
            variables() {
                return {
                    user_id: this.userId,
                };
            },
            error(error) {
                this.error = JSON.stringify(error.message);
            },
            result() {
                if(this.unselectedCategories === null && this.categories ) {
                    if (this.initialCategories.length) {
                        this.unselectedCategories = this.categories.filter(x => !this.initialCategories.includes(x.id));
                        this.selectedCategories = this.categories.filter(x => this.initialCategories.includes(x.id));
                    } else {
                        this.unselectedCategories = JSON.parse(JSON.stringify(this.categories));
                    }
                }
            },
        }
    },
    data() {
        return {
            showCategories: false,
            selectedCategories: [],
            unselectedCategories: null,
        }
    },
    methods: {
        selectNewCategory(category) {
            const index = this.unselectedCategories.indexOf(category);
            if (index > -1) {
                this.unselectedCategories.splice(index, 1);
            }
            this.selectedCategories.push(category);
        },
        unselectCategory(category) {
            const index = this.selectedCategories.indexOf(category);
            if (index > -1) {
                this.selectedCategories.splice(index, 1);
            }
            this.unselectedCategories.push(category);
        },
        handleNewCategory(newCategory) {
            this.$apollo.queries.categories.refetch();
            this.selectedCategories.push(newCategory);
        },
        resetCategories() {
            this.unselectedCategories = [];
            this.selectedCategories = [];
        },
        resetSelectedCategories() {
            this.selectedCategories = [];
            this.unselectedCategories = JSON.parse(JSON.stringify(this.categories));

        }
    },
    watch: {
        selectedCategories: function () {
            this.$emit('input', this.selectedCategories);
        }
    },
    beforeDestroy() {
        this.resetCategories();
    },
}
</script>

<style scoped>
.category-filter {
    display: inline;
}
.category-filter .select-categories {
    background: #e8e8e8;
    display: inline-block;
    padding: 6px 8px;
    font-weight: 700;
    color: #565656;
    border-radius: 4px;
    margin-right: 8px;
}
.category-filter .select-categories i {
    font-size: 20px;
    vertical-align: middle;
}
.category-filter > * {
    display: inline-block;
}
.category-filter .selected-categories {
    display: inline;
}

.category-filter .selected-categories .selected-category,
.category-filter .categories-list .category.selected {
    display: inline-block;
    color: #5A4BB0;
    padding: 6px 8px;
    border-radius: 4px;
    margin-right: 8px;
    background-color: #eceeff;
    margin-bottom: 8px;
}
.category-filter .categories-list {
    display: block;
    position: absolute;
    z-index: 20;
    background: white;
    padding: 12px 12px 4px 12px;
    margin-top: 8px;
    box-shadow: 0px 0px 10px rgb(0 0 0 / 15%);
    border: 1px solid #D9D5D5;
    border-radius: 4px;
    max-width: 400px;
    margin-right: 20px;
}

.category-filter .categories-list .category {
    display: inline-block;
    color: #484848;
    padding: 6px 8px;
    border-radius: 4px;
    margin-right: 8px;
    background-color: #f1f1f1;
    margin-bottom: 8px;
}
</style>